const HOME = {
  route: '/',
  name: 'Home',
  icon: 'HOME'
};

export default [HOME];
